import { render, staticRenderFns } from "./RemDetail.vue?vue&type=template&id=7aa727d5&scoped=true"
import script from "./RemDetail.vue?vue&type=script&lang=js"
export * from "./RemDetail.vue?vue&type=script&lang=js"
import style0 from "./RemDetail.vue?vue&type=style&index=0&id=7aa727d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa727d5",
  null
  
)

export default component.exports